exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "input[type=file][data-v-323ea8c4]{position:absolute;top:-500px}div.file-listing[data-v-323ea8c4]{width:200px}.drop-zone[data-v-323ea8c4]{display:block;width:100%;height:100%;min-height:6em;text-align:center;border:.15em dashed currentColor}.drop-zone-active[data-v-323ea8c4]:hover{border:.15em solid currentColor;cursor:pointer}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-323ea8c4","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/PhotoUpload.vue
// module id = 420
// module chunks = 0